import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { exchangeGoogleSession } from "../lib/api";
import { useAuth } from "../auth";

export const AuthCallback = () => {
  const { setUser } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = location.hash.split("session_id=")[1]?.split("&")[0];
    exchangeGoogleSession(sessionId)
      .then((u) => {
        setUser(u);
        navigate("/", { replace: true, state: { user: u } });
      })
      .catch(() => {
        toast.error("Google sign-in failed");
        navigate("/login", { replace: true });
      });
  }, []);

  return (
    <div className="min-h-screen bg-black flex items-center justify-center" data-testid="auth-callback">
      <span className="font-meta text-xs uppercase tracking-[0.3em] text-zinc-600">Taking your seat…</span>
    </div>
  );
};
